var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"bg py-12"},[_c('job-details',{attrs:{"id":_vm.jobId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }